import React from "react";

import SongListItem from "./song-list-item";
import { useAudioPlayer } from "../../context/audio-player-context";

function chunkArray<T extends readonly unknown[]>(array: T, size: number): T[] {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    const chunk = array.slice(i, i + size);
    result.push(chunk);
  }
  return result;
}

type Props = {
  songs: Songs;
  isLoading: boolean;
};

const SongsListSlider: React.FC<Props> = props => {
  const { setCurrentSong, setSongs } = useAudioPlayer();

  const playSong = (song: Song, index: number) => {
    setCurrentSong(song);
    setSongs(props.songs, index);
  };

  const songs = chunkArray(props.songs || [], 2);

  return (
    <div className="flex space-x-3 overflow-x-auto flex-nowrap scrolling-wrapper">
      <div className="flex-shrink-0 w-px"></div>

      {songs.map((_songs, index) => (
        <div className="flex-shrink-0 w-10/12 max-w-sm space-y-2" key={index}>
          {_songs.map(song => (
            <SongListItem key={song.id} song={song} play={() => playSong(song, index)} />
          ))}
        </div>
      ))}

      {props.isLoading &&
        Array.from(Array(3).keys()).map(id => (
          <div className="flex-shrink-0 w-10/12 max-w-sm space-y-2" key={id}>
            {[1, 2].map(i => (
              <div key={i} className="flex bg-gray-200 rounded-md animate-pulse">
                <div className="w-24 h-20 bg-gray-400 rounded-l-md" />

                <div className="flex-1 px-3 py-2">
                  <p className="h-4 pr-4 bg-gray-400 rounded-lg" />
                  <p className="w-3/4 h-2 mt-2 bg-gray-400 rounded-lg" />
                </div>
              </div>
            ))}
          </div>
        ))}

      <div className="flex-shrink-0 w-px"></div>
    </div>
  );
};

export default SongsListSlider;
